import { brand } from "@/shared/lib/safecheckBrand";

export const hospitalDashboardData = {
  header: {
    totalInvoices: 9,
    monthlyRevenue: "$0",
    providerBadge: "Medecin de nuit",
    displayDate: "26 juin 2026",
  },
  indicators: [
    {
      id: "invoices",
      value: 9,
      icon: "file",
      iconClassName: "bg-teal-soft text-teal",
      footerKey: "cumulative",
      footerIcon: "minus",
      footerClassName: "text-muted",
    },
    {
      id: "submitted",
      value: 1,
      icon: "upload",
      iconClassName: "bg-yellow-soft text-yellow",
      footerKey: "pending",
      footerIcon: "hourglass",
      footerClassName: "text-pink",
    },
    {
      id: "paid",
      value: 0,
      icon: "wallet",
      iconClassName: "bg-teal-soft text-green",
      footerKey: "settled",
      footerIcon: "dollar",
      footerClassName: "text-green",
    },
    {
      id: "review",
      value: 6,
      icon: "clock",
      iconClassName: "bg-primary-soft text-primary",
      footerKey: "inProgress",
      footerIcon: "activity",
      footerClassName: "text-muted",
    },
    {
      id: "approved",
      value: 2,
      icon: "check",
      iconClassName: "bg-teal-soft text-green",
      footerKey: "validated",
      footerIcon: "trending",
      footerClassName: "text-green",
    },
    {
      id: "rejected",
      value: 0,
      icon: "x",
      iconClassName: "bg-pink-soft text-pink",
      footerKey: "toFix",
      footerIcon: "x",
      footerClassName: "text-pink",
    },
    {
      id: "revenue",
      value: "$0",
      icon: "dollar",
      iconClassName: "bg-orange-100 text-orange-500",
      footerKey: "thisMonth",
      footerIcon: "trending",
      footerClassName: "text-green",
    },
  ],
  quickActions: [
    { id: "control", href: "/dashboard/claims/control", icon: "plus", iconClassName: "text-green" },
    { id: "settlements", href: "/dashboard/claims/settlements", icon: "upload", iconClassName: "text-primary" },
    { id: "invoices", href: "/dashboard/invoices", icon: "file", iconClassName: "text-green" },
    { id: "portfolio", href: "/dashboard/claims/portfolio", icon: "home", iconClassName: "text-purple" },
  ],
  invoiceDistribution: [
    { key: "submitted", value: 1, color: "#eab308" },
    { key: "review", value: 6, color: brand.navyLight },
    { key: "approved", value: 2, color: brand.limeDark },
    { key: "paid", value: 0, color: brand.lime },
    { key: "rejected", value: 0, color: "#ef4444" },
  ],
  financials: {
    totalBilled: "$298,856.96",
    paid: "$0.00",
    pending: "$298,856.96",
    validationRate: "22.2%",
  },
  topClients: [
    {
      rank: 1,
      company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
      invoiceCount: 9,
      totalAmount: 298856.96,
    },
  ],
  companyFilterOptions: [
    { value: "", labelKey: "allCompanies" as const },
    {
      value: "ceec",
      label: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    },
  ],
  submittedInvoices: [
    {
      id: "h-inv-13",
      displayId: 13,
      company: "ceec",
      amount: 25640.96,
      submittedDate: "06/06/2026",
      delayDays: 20,
      urgent: true,
    },
  ],
} as const;

export type HospitalSubmittedInvoice = (typeof hospitalDashboardData.submittedInvoices)[number];
